import { render, staticRenderFns } from "./TempQuotationCreateProcess.vue?vue&type=template&id=2084342c"
import script from "./TempQuotationCreateProcess.vue?vue&type=script&lang=js"
export * from "./TempQuotationCreateProcess.vue?vue&type=script&lang=js"
import style0 from "./TempQuotationCreateProcess.vue?vue&type=style&index=0&id=2084342c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports